/**
 * @generated SignedSource<<d2a1621c6d20c811ed38975d267a2cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PromotionActionEnum = "promotion_activate" | "promotion_create" | "promotion_deactivate" | "promotion_delete" | "promotion_update" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PromotionActionsMutationButtonStack_promotion$data = {
  readonly actions: ReadonlyArray<PromotionActionEnum>;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionUpdateDialog_promotion">;
  readonly " $fragmentType": "PromotionActionsMutationButtonStack_promotion";
};
export type PromotionActionsMutationButtonStack_promotion$key = {
  readonly " $data"?: PromotionActionsMutationButtonStack_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionActionsMutationButtonStack_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionActionsMutationButtonStack_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromotionUpdateDialog_promotion"
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "5b4403ad30194ee2fe304a7c98f1c949";

export default node;
